<template>
  <SearchHelper page="timeline" v-slot="slotProps">
    <TimelineBody v-bind="slotProps" />
  </SearchHelper>
</template>

<script>
import SearchHelper from '@/components/SearchHelper'
import TimelineBody from '@/components/bodies/TimelineBody'

export default {
  components: {
    SearchHelper,
    TimelineBody
  }
}
</script>

<style scoped lang="scss"></style>
